import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { Paper, Typography, Box } from '@mui/material';

const LocationMap = ({ latitude, longitude, title }) => {
  const mapContainerStyle = {
    width: '100%',
    height: '400px',
  };

  const center = {
    lat: parseFloat(latitude),
    lng: parseFloat(longitude),
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Location
      </Typography>
      <Box sx={{ width: '100%', height: '400px' }}>
        <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={16}
          >
            <Marker
              position={center}
              title={title}
            />
          </GoogleMap>
        </LoadScript>
      </Box>
    </Paper>
  );
};

export default LocationMap; 